import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PulseLoader from "react-spinners/PulseLoader";

const useStyle = makeStyles(() => ({
  spinner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    fontSize: "14px",
    fontWeight: "bold",
  },
}));

interface Props {
  height?: string;
}

const KLoader = ({ height = "100vh" }: Props) => {
  const classes = useStyle();
  return (
    <div className={classes.spinner} style={{ height }}>
      <PulseLoader size={10} color="#383E52" />
    </div>
  );
};

export default KLoader;
